import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import EditDealershipSettings from '../../../inputs/EditDealershipSettings';
import EditTabStyle from './EditTabStyle';
import EditTabProperties from '../../../inputs/EditTabProperties';

const EditEstimates = (props) => {
    const [errors, setErrors] = useState({ editTab: false });
    const [optionName, setOptionName] = useState('');
    const dispatch = useDispatch();

    const handleChange = (e) => {
        setOptionName(e.target.value);
    };

    return (
        <div className="col-md-12">
            <h3 className="text-center">Form Settings</h3>

            <div className="card space-top-1">
                <div className="card-header">
                    <div className="col-md-12">
                        <small>
                            <i className={'fa fa-info-circle text-info'} />
                            {' '}
                            Ro/Item Number.
                        </small>
                    </div>
                </div>

                <div className="card-body">
                    <EditTabProperties 
                        {...props} 
                        type={'text-prepend'} 
                        name={'ro_number_label'} 
                        label={'Ro Number Label'} 
                        value={'Ro Number'} 
                        dataid={props.tab.id} 
                    />
                    <EditTabProperties 
                        {...props} 
                        type={'switch'} 
                        name={'ro_number_required'} 
                        label={'Required (not blank)'} 
                        value={'true'} 
                        dataid={props.tab.id} 
                    />
                    <EditTabProperties 
                        {...props} 
                        type={'switch'} 
                        name={'ro_number_lockable'} 
                        label={'Lockable'} 
                        value={'true'} 
                        dataid={props.tab.id} 
                    />
                    <EditTabProperties 
                        {...props} 
                        type={'switch'} 
                        name={'include_in_notification'} 
                        label={'Include in Notification'} 
                        value={'true'} 
                        dataid={props.tab.id} 
                    />
                </div>
            </div>

            <div className="card space-top-1">
                <div className="card-text">
                    <h3>Form Settings</h3>

                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>Label</th>
                                <th>Required?</th>
                                <th>Allow Lock</th>
                                <th>Include in Notification</th>
                                <th>Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td />
                                <td />
                                <td />
                                <td />
                                <td />
                            </tr>
                        </tbody>
                    </table>

                    <h3>Description</h3>
                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>Label</th>
                                <th>Required?</th>
                                <th>Allow Lock</th>
                                <th>Include in Notification</th>
                                <th>Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td />
                                <td />
                                <td />
                                <td />
                                <td />
                            </tr>
                        </tbody>
                    </table>

                    <h3>Amount</h3>
                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>Label</th>
                                <th>Required?</th>
                                <th>Allow Lock</th>
                                <th>Include in Notification</th>
                                <th>Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td />
                                <td />
                                <td />
                                <td />
                                <td />
                            </tr>
                        </tbody>
                    </table>

                    <h3>Attachments</h3>
                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>Label</th>
                                <th>Required?</th>
                                <th>Allow Lock</th>
                                <th>Include in Notification</th>
                                <th>Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td />
                                <td />
                                <td />
                                <td />
                                <td />
                            </tr>
                        </tbody>
                    </table>

                    <h3>Recipients</h3>
                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>Label</th>
                                <th>Required?</th>
                                <th>Allow Lock</th>
                                <th>Include in Notification</th>
                                <th>Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td />
                                <td />
                                <td />
                                <td />
                                <td />
                            </tr>
                        </tbody>
                    </table>

                    <h3>Notification Settings</h3>
                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>Label</th>
                                <th>Required?</th>
                                <th>Allow Lock</th>
                                <th>Include in Notification</th>
                                <th>Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td />
                                <td />
                                <td />
                                <td />
                                <td />
                            </tr>
                        </tbody>
                    </table>

                    <h3>Status Settings</h3>
                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>Label</th>
                                <th>Required?</th>
                                <th>Allow Lock</th>
                                <th>Include in Notification</th>
                                <th>Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td />
                                <td />
                                <td />
                                <td />
                                <td />
                            </tr>
                        </tbody>
                    </table>

                    <h3>Lockable</h3>
                    <table className="table table-striped table-sm">
                        <thead className={'thead text-center'}>
                            <tr>
                                <th>Label</th>
                                <th>Required?</th>
                                <th>Allow Lock</th>
                                <th>Include in Notification</th>
                                <th>Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td />
                                <td />
                                <td />
                                <td />
                                <td />
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default EditEstimates;